"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchResultItemContent_v2 = void 0;
exports.SearchResultItemContent_v2 = {
  en: {
    products: "Products",
    addToCart: "Add to Cart",
    moreInProducts: "More in Products",
    otherProducts: "Other Products",
    matchingProducts: "Matching Products",
    productCategory: "Product Category",
    articlesResources: "Articles & Resources",
    recentlyPurchased: "Recently Purchased",
    tbd: "TBD",
    noResults: "No results found",
    leadTime: "Lead Time",
    quantity: "Qty",
    priceUom: "Price (UOM)",
    gauge: "The Gauge",
    locations: "Locations",
    other: "Other",
    moreInProductCategories: "More in Product Categories",
    moreInGauge: "More in The Gauge",
    moreInLocations: "More in Locations",
    moreInOther: "More in Other"
  },
  fr: {
    products: "Produits",
    addToCart: "Ajouter chariot",
    moreInProducts: "Plus dans Produits",
    otherProducts: "Autres produits",
    matchingProducts: "Produits assortis",
    productCategory: "Catégorie de Produit",
    articlesResources: "Articles et ressources",
    recentlyPurchased: "Récemment achetés:",
    tbd: "à déterminer",
    noResults: "Aucun résultat trouvé",
    leadTime: "Délai",
    quantity: "Qté",
    priceUom: "Prix (UdM)",
    gauge: "Le calibre",
    locations: "Emplacements",
    other: "Autre",
    moreInProductCategories: "Plus dans Catégories de Produits",
    moreInGauge: "Plus dans Le Calibre",
    moreInLocations: "Plus dans Emplacements",
    moreInOther: "Plus dans Autre"
  },
  es: {
    products: "Productos",
    addToCart: "Añadir al carrito",
    moreInProducts: "Más en Productos",
    otherProducts: "Otros productos",
    matchingProducts: "Productos a juego",
    productCategory: "Categoría de Producto",
    articlesResources: "Artículos y recursos",
    recentlyPurchased: "Recientemente comprados ",
    tbd: "por determinar",
    noResults: "No se encontraron resultados",
    leadTime: "Demora",
    quantity: "Qtd",
    priceUom: "Precio (UdM)",
    gauge: "El calibre",
    locations: "Ubicación",
    other: "Otro",
    moreInProductCategories: "Más en Categorías de Producto",
    moreInGauge: "Más en El Calibre",
    moreInLocations: "Más en Ubicación",
    moreInOther: "Más en Otro"
  }
};